


















import { defineComponent, PropType, ref } from '~/utils/nuxt3-migration'
import { CartSellerInfo } from '~/models/marketplace/cart'
import MarketplaceSellerInfoModal from '~/components/car/marketplace/seller/MarketplaceSellerInfoModal.vue'

export default defineComponent({
  components: { MarketplaceSellerInfoModal },
  props: {
    seller: {
      type: Object as PropType<CartSellerInfo>,
      required: true
    },
    orderId: {
      type: Number,
      required: false,
      default: undefined
    },
    colorClass: {
      type: String,
      required: false,
      default: 'tw-text-blue-500'
    }
  },
  setup() {
    const showModal = ref(false)
    return {
      showModal
    }
  }
})
